import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbTextInput',
  props: {
  value: {
    type: [String, Number],
    default: null,
  },
  placeholder: {
    type: String,
    default: ' ',
  },
  label: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  error: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  min: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const input = ref();

const classes = computed(() => [
  'border-gray-100',
  props.error && 'ab-text-input__input--error',
  props.label && 'ab-text-input__input--with-label',
]);

const blur = () => {
  input.value.blur();
};

return { __sfc: true,props, emit, valueLocal, input, classes, blur }
}

})